(function () {
  'use strict';

  function selectedMediaId(main) {
    var selected = main.querySelector('[data-product-gallery-media].is-selected');
    return selected ? selected.getAttribute('data-media-id') : null;
  }

  function selectGalleryMedia(main, thumbnail) {
    var mediaId = thumbnail.getAttribute('data-media-id');
    if (!mediaId) return false;
    var target = Array.prototype.find.call(main.querySelectorAll('[data-product-gallery-media]'), function (cell) {
      return cell.getAttribute('data-media-id') === mediaId;
    });
    if (!target) return false;
    if (window.jQuery) {
      var instance = window.jQuery(main).data('flickity');
      if (instance && instance.getCell(target)) {
        instance.selectCell(target);
        return true;
      }
    }
    target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    return true;
  }

(function () {
  'use strict';

  /* Block stagger indices */
  function initStagger() {
    document.querySelectorAll('.pf-details .pf-block, .pf-details details').forEach(function (el, i) {
      el.style.setProperty('--pf-bi', i);
    });
  }

  /* Tabs below gallery */
  function initTabs() {
    document.querySelectorAll('.pf-tabs').forEach(function (tabs) {
      var btns = tabs.querySelectorAll('.pf-tabs__btn');
      var section = tabs.closest('.pf-tabs-section');
      if (!section) return;
      var panels = section.querySelectorAll('.pf-tabs__panel');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-pf-tab');
          btns.forEach(function (b) { b.classList.remove('is-active'); });
          panels.forEach(function (p) { p.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var panel = section.querySelector('[data-pf-panel="' + target + '"]');
          if (panel) panel.classList.add('is-active');
        });
      });
    });
  }

  /* Show selected swatch name */
  function initSwatchNames() {
    document.querySelectorAll('.pf-swatch').forEach(function (swatch) {
      var display = swatch.querySelector('[data-swatch-selected]');
      if (!display) return;
      function update() {
        var sel = swatch.querySelector('.pf-swatch__input:checked');
        if (sel) display.textContent = sel.value;
      }
      update();
      swatch.querySelectorAll('.pf-swatch__input').forEach(function (input) {
        input.addEventListener('change', update);
      });
    });
  }



  /* Mobile gallery thumbnails: keep the strip clickable even if theme nav init is inconsistent */
  function initMobileGalleryThumbs() {
    document.querySelectorAll('.pf-gallery .gallery-wrap').forEach(function (wrap) {
      var main = wrap.querySelector('.product_gallery');
      var nav = wrap.querySelector('.product_gallery_nav');
      if (!main || !nav || nav.dataset.pfMobileThumbsInit === 'true') return;
      nav.dataset.pfMobileThumbsInit = 'true';

      var thumbs = Array.prototype.slice.call(nav.querySelectorAll('.gallery-cell'));
      if (!thumbs.length) return;

      function selectThumb(index) {
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('is-nav-selected', i === index);
          thumb.classList.toggle('is-selected', i === index);
          if (i === index) {
            thumb.setAttribute('aria-current', 'true');
            try { thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); } catch (e) {}
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }

      thumbs.forEach(function (thumb, index) {
        thumb.setAttribute('role', 'button');
        thumb.setAttribute('aria-label', 'View product image ' + (index + 1));
        thumb.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (selectGalleryMedia(main, thumb)) selectThumb(index);
        });

        thumb.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            thumb.click();
          }
        });
      });

      selectThumb(0);

      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.flickity) {
        try {
          window.jQuery(main).on('change.flickity', function () {
            var mediaId = selectedMediaId(main);
            var index = thumbs.findIndex(function (thumb) { return thumb.getAttribute('data-media-id') === mediaId; });
            if (index !== -1) selectThumb(index);
          });
        } catch (e) {}
      }
    });
  }



  /* Keep custom Profusion swatches and the Shopify variant field in sync. */
  function initVariantSelectionSync() {
    document.querySelectorAll('[data-product-form]').forEach(function (productForm) {
      if (productForm.dataset.pfVariantSyncInit === 'true') return;
      productForm.dataset.pfVariantSyncInit = 'true';

      var form = productForm.querySelector('form[action*="/cart/add"]') || productForm.querySelector('form');
      var masterSelect = productForm.querySelector('select[name="id"][data-variants]');
      if (!form || !masterSelect) return;

      var product;
      try {
        product = JSON.parse(productForm.getAttribute('data-product') || '{}');
      } catch (error) {
        product = null;
      }
      if (!product || !Array.isArray(product.variants)) return;

      function selectedOptions() {
        var values = [];
        productForm.querySelectorAll('.pf-swatch').forEach(function (group) {
          var index = Number(group.getAttribute('data-option-index'));
          var checked = group.querySelector('.pf-swatch__input:checked');
          if (checked && Number.isFinite(index)) values[index] = checked.value;
        });
        return values;
      }

      function matchingVariant() {
        var values = selectedOptions();
        return product.variants.find(function (variant) {
          return variant.options.every(function (value, index) {
            return values[index] == null || String(values[index]) === String(value);
          });
        }) || null;
      }

      function syncGeneratedSelectors(values) {
        var generated = productForm.querySelectorAll('.single-option-selector');
        generated.forEach(function (selector, index) {
          if (values[index] != null && selector.value !== values[index]) {
            selector.value = values[index];
            selector.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      function syncVariant() {
        var values = selectedOptions();
        syncGeneratedSelectors(values);
        var variant = matchingVariant();
        if (!variant) return null;
        if (String(masterSelect.value) !== String(variant.id)) {
          masterSelect.value = String(variant.id);
          masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return variant;
      }

      productForm.querySelectorAll('.pf-swatch__input').forEach(function (input) {
        input.addEventListener('change', syncVariant);
      });

      form.addEventListener('submit', function () {
        /* Final safeguard: the submitted id must always be the visibly selected variant. */
        syncVariant();
      }, true);

      syncVariant();
    });
  }

  /* Mobile floating Add to Cart removed intentionally. */
  function initSticky() { return; }

  function init() {
    if (!document.querySelector('.pf-product')) return;
    initStagger();
    initTabs();
    initSwatchNames();
    initVariantSelectionSync();
    /* Sticky/floating mobile Add to Cart removed per Profusion request. */
    initMobileGalleryThumbs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Profusion mobile gallery controls and counter */
(function () {
  'use strict';

  function initProfusionMobileGalleryUI() {
    document.querySelectorAll('.pf-gallery .gallery-wrap').forEach(function (wrap) {
      if (wrap.dataset.pfGalleryUiInit === 'true') return;
      var main = wrap.querySelector('.product_gallery');
      if (!main) return;
      var cells = Array.prototype.slice.call(main.querySelectorAll('.gallery-cell'));
      if (cells.length < 2) return;
      wrap.dataset.pfGalleryUiInit = 'true';

      var counter = document.createElement('div');
      counter.className = 'pf-gallery-count';
      counter.setAttribute('aria-live', 'polite');
      main.appendChild(counter);

      var prev = wrap.querySelector('.flickity-prev-next-button.previous');
      var next = wrap.querySelector('.flickity-prev-next-button.next');

      if (!prev) {
        prev = document.createElement('button');
        prev.type = 'button';
        prev.className = 'pf-gallery-arrow pf-gallery-arrow--prev';
        prev.setAttribute('aria-label', 'Previous product image');
        prev.innerHTML = '&#8249;';
        main.appendChild(prev);
      }
      if (!next) {
        next = document.createElement('button');
        next.type = 'button';
        next.className = 'pf-gallery-arrow pf-gallery-arrow--next';
        next.setAttribute('aria-label', 'Next product image');
        next.innerHTML = '&#8250;';
        main.appendChild(next);
      }

      var index = 0;
      function update(nextIndex) {
        index = Math.max(0, Math.min(cells.length - 1, Number(nextIndex) || 0));
        counter.textContent = (index + 1) + ' / ' + cells.length;
        prev.disabled = index === 0;
        next.disabled = index === cells.length - 1;
      }

      function select(targetIndex) {
        var bounded = Math.max(0, Math.min(cells.length - 1, targetIndex));
        if (window.jQuery && window.jQuery.fn && window.jQuery.fn.flickity) {
          try {
            window.jQuery(main).flickity('select', bounded);
            update(bounded);
            return;
          } catch (error) {}
        }
        if (cells[bounded]) {
          cells[bounded].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          update(bounded);
        }
      }

      prev.addEventListener('click', function () { select(index - 1); });
      next.addEventListener('click', function () { select(index + 1); });

      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.flickity) {
        try {
          window.jQuery(main).on('change.flickity.pfGalleryUi', function (event, selectedIndex) {
            update(selectedIndex);
          });
          var instance = window.jQuery(main).data('flickity');
          if (instance && Number.isFinite(instance.selectedIndex)) index = instance.selectedIndex;
        } catch (error) {}
      }

      main.addEventListener('scroll', function () {
        if (window.jQuery && window.jQuery.fn && window.jQuery.fn.flickity) return;
        var width = main.clientWidth || 1;
        update(Math.round(main.scrollLeft / width));
      }, { passive: true });

      update(index);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProfusionMobileGalleryUI);
  } else {
    initProfusionMobileGalleryUI();
  }

  document.addEventListener('shopify:section:load', initProfusionMobileGalleryUI);
})();

/* Profusion desktop product thumbnail rail.
   Uses direct thumbnail images so every item renders reliably, never wraps,
   and does not alter the existing mobile gallery. */
(function () {
  'use strict';

  function isDesktop() {
    return window.matchMedia && window.matchMedia('(min-width: 799px)').matches;
  }

  function initDesktopThumbSlider(scope) {
    var context = scope || document;
    var sliders = context.querySelectorAll
      ? context.querySelectorAll('[data-pf-desktop-thumb-slider]')
      : [];

    sliders.forEach(function (slider) {
      if (slider.dataset.pfDesktopThumbInit === 'true') return;
      slider.dataset.pfDesktopThumbInit = 'true';

      var track = slider.querySelector('[data-pf-desktop-thumb-track]');
      var previous = slider.querySelector('[data-pf-desktop-thumb-prev]');
      var next = slider.querySelector('[data-pf-desktop-thumb-next]');
      var buttons = Array.prototype.slice.call(
        slider.querySelectorAll('[data-pf-desktop-thumb-index]')
      );
      var wrap = slider.closest('.gallery-wrap');
      var main = wrap ? wrap.querySelector('.product_gallery') : null;

      if (!track || !main || !buttons.length) return;

      function syncVariantThumbnails() {
        var mediaIds = Array.prototype.map.call(main.querySelectorAll('[data-product-gallery-media]'), function (cell) {
          return cell.getAttribute('data-media-id');
        });
        buttons.forEach(function (button) {
          button.style.display = mediaIds.indexOf(button.getAttribute('data-media-id')) === -1 ? 'none' : '';
        });
        var activeId = selectedMediaId(main);
        var activeIndex = buttons.findIndex(function (button) { return button.getAttribute('data-media-id') === activeId; });
        if (activeIndex !== -1) setActive(activeIndex, false);
        updateOverflow();
      }

      function setActive(index, reveal) {
        var safeIndex = Math.max(0, Math.min(buttons.length - 1, Number(index) || 0));
        buttons.forEach(function (button, buttonIndex) {
          var active = buttonIndex === safeIndex;
          button.classList.toggle('is-active', active);
          if (active) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });

        if (reveal && buttons[safeIndex] && isDesktop()) {
          var item = buttons[safeIndex];
          var itemLeft = item.offsetLeft;
          var itemRight = itemLeft + item.offsetWidth;
          var visibleLeft = track.scrollLeft;
          var visibleRight = visibleLeft + track.clientWidth;
          if (itemLeft < visibleLeft || itemRight > visibleRight) {
            track.scrollTo({
              left: Math.max(0, itemLeft - (track.clientWidth - item.offsetWidth) / 2),
              behavior: 'smooth'
            });
          }
        }
      }

      function selectMain(index) {
        var safeIndex = Math.max(0, Math.min(buttons.length - 1, Number(index) || 0));
        if (selectGalleryMedia(main, buttons[safeIndex])) setActive(safeIndex, true);
      }

      function updateOverflow() {
        if (!isDesktop()) return;
        var overflowing = track.scrollWidth > track.clientWidth + 2;
        slider.classList.toggle('is-overflowing', overflowing);
        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        if (previous) previous.disabled = !overflowing || track.scrollLeft <= 2;
        if (next) next.disabled = !overflowing || track.scrollLeft >= maxScroll - 2;
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          selectMain(Number(button.getAttribute('data-pf-desktop-thumb-index')) || 0);
        });
      });

      if (previous) {
        previous.addEventListener('click', function () {
          track.scrollBy({ left: -Math.max(220, track.clientWidth * 0.76), behavior: 'smooth' });
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: Math.max(220, track.clientWidth * 0.76), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateOverflow);
      }, { passive: true });

      if (window.jQuery) {
        try {
          window.jQuery(main).on('select.flickity.pfDesktopThumbRail change.flickity.pfDesktopThumbRail', function () {
            var instance = window.jQuery(main).data('flickity');
            if (instance && Number.isFinite(instance.selectedIndex)) {
              var mediaId = selectedMediaId(main);
              var index = buttons.findIndex(function (button) { return button.getAttribute('data-media-id') === mediaId; });
              if (index !== -1) setActive(index, true);
            }
          });
        } catch (error) {}
      }

      var resizeObserver;
      if (window.ResizeObserver) {
        resizeObserver = new ResizeObserver(updateOverflow);
        resizeObserver.observe(track);
      } else {
        window.addEventListener('resize', updateOverflow);
      }

      setActive(0, false);
      syncVariantThumbnails();
      var galleryObserver = new MutationObserver(syncVariantThumbnails);
      galleryObserver.observe(main, { childList: true, subtree: true });
      window.requestAnimationFrame(updateOverflow);
      window.setTimeout(updateOverflow, 250);
      window.setTimeout(updateOverflow, 900);
    });
  }

  function init() {
    initDesktopThumbSlider(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initDesktopThumbSlider(event.target || document);
  });
})();


})();
